import { IActivePass, IPassGroup } from '../../models'
import { BaseHttpService } from './base'

export interface IBuyPassResponse {
  clientSecret: string
}

class PassesService extends BaseHttpService {
  public getActivePasses = async (): Promise<IActivePass[]> => {
    return this.get('passes/active')
  }

  public getAvailablePasses = async (): Promise<IPassGroup[]> => {
    return this.get('passes')
  }

  public buyPass = async (passId: number): Promise<IBuyPassResponse> => {
    return this.post(`passes/${passId}`, {})
  }

  public usePass = async (activePassId: number, reservationId: number): Promise<any> => {
    return this.post(`passes/active/${activePassId}/use/${reservationId}`, {})
  }
}

export default new PassesService()
